import styled from 'styled-components';

const Title = styled.h2`
  ${({ theme }) => theme.fontFamily.mainFont.mediumExtraBold};
  padding-bottom: ${({ theme, isModal }) => theme.spacing(isModal ? 16 : 11)};
  margin: 0;
  text-align: center;
`;

export default Title;
